<template>
  <p
    v-if="canShow(showRules)"
    :class="[{ 'animate-pulse': blinking }, componentClasses]"
    :style="{ fontWeight: fontWeight || 500, fontSize: fontSize }"
    class="w-full p-0.5 ps-2 rounded text-xs"
  >
    <slot></slot>
  </p>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import useVisible from '@/composables/useVisible'

const props = defineProps({
  background: String,
  blinking: Boolean,
  fontWeight: Number,
  size: Number,
  showRules: Object
})

const { findShowRule, getBindObj } = useVisible()
const route = useRoute()

const fontSize = computed(() => {
  return `${props.size || 14.0}px`
})

const componentClasses = computed(() => {
  if (props.background == 'outline') {
    return 'border border-primary text-primary'
  }

  if (props.background == 'dashed') {
    return 'border border-dashed border-primary text-primary'
  }

  if (props.background == 'filled') return 'bg-primary text-white'

  return 'text-primary'
})

const canShow = (showRules, deviceType) => {
  if (deviceType === 'mobile') return false
  if (!showRules) return true

  return findShowRule(
    showRules.any || showRules.all,
    showRules.any ? 'any' : 'all',
    getBindObj(route.params.serviceId)
  )
}
</script>

<style lang="scss" scoped></style>
